(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-switcher"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initSwitcher(root) {
    if (root.dataset.fsReady === 'true') return;
    root.dataset.fsReady = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.feature-card'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.feature-panel'));
    if (!cards.length) return;

    function panelFor(id) {
      return panels.filter(function (p) { return p.dataset.panel === id; })[0];
    }

    function activate(card, focusCard) {
      var id = card.dataset.card;
      if (card.classList.contains('is-active') && root.dataset.fsInit === 'done') {
        return; // no-op, prevents unnecessary re-render
      }

      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
      });

      panels.forEach(function (p) {
        var on = p.dataset.panel === id;
        if (on) {
          p.hidden = false;
          // force reflow so the entrance animation replays each activation
          void p.offsetWidth;
          p.classList.add('is-active');
        } else {
          p.classList.remove('is-active');
          // hide after the fade-out completes (keeps it out of a11y tree)
          window.setTimeout(function () {
            if (!p.classList.contains('is-active')) p.hidden = true;
          }, 400);
        }
      });

      if (focusCard) card.focus();
      root.dataset.fsInit = 'done';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { activate(card, false); });
    });

    // Roving tabindex keyboard navigation for the tablist
    var list = root.querySelector('.feature-switcher__cards');
    if (list) {
      list.addEventListener('keydown', function (e) {
        var idx = cards.indexOf(document.activeElement);
        if (idx === -1) return;
        var next = null;
        switch (e.key) {
          case 'ArrowDown':
          case 'ArrowRight': next = cards[(idx + 1) % cards.length]; break;
          case 'ArrowUp':
          case 'ArrowLeft': next = cards[(idx - 1 + cards.length) % cards.length]; break;
          case 'Home': next = cards[0]; break;
          case 'End': next = cards[cards.length - 1]; break;
          default: return;
        }
        e.preventDefault();
        activate(next, true);
      });
    }

    // Auto-select the first block on load
    if (root.dataset.autoselect === 'true') {
      activate(cards[0], false);
    }
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('[data-feature-switcher]').forEach(initSwitcher);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Theme editor lifecycle: re-init and reflect block selection
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest('.feature-card') ||
      e.target.querySelector('.feature-card') ||
      document.getElementById('fs-tab-' + e.target.dataset.sectionId + '-' + e.detail.blockId);
    // Fallback: find the card matching the selected block id inside this section
    var section = e.target.closest('[data-feature-switcher]') || e.target;
    if (section) {
      var match = section.querySelector('.feature-card[data-card="' + e.detail.blockId + '"]');
      if (match) match.click();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
